var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsDe = function SvgNnIconFlagsDe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.2 32.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#050807",
    d: "M16.1.199C9.63.036 3 4.699 1.2 10.599h29.9c-2.19-6.17-8.45-10.5-15-10.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0005",
    d: "M31.1 10.6h-30c-1.27 3.45-1.53 7.98.203 11.1h29.8c1.35-3.54 1.35-7.56 0-11.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc00",
    d: "M16.1 32.1c6.47.163 13.1-4.5 14.9-10.4H1.1c2.19 6.17 8.45 10.5 15 10.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "none",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
};
export default SvgNnIconFlagsDe;